import * as actionTypes from "../constants";
import { updateObject } from "../../utils";

const initialState = {
  userAlreadyExist: false,
  userDoesNotExist: false,
  errorVerify: false,
  userVerified: false,
  userIdType: null,
  userIdNumber: null,
  email: null,
  isSendEmail: null,
  isReSendEmail: null,
  isNotValidToken: null,
  loadingToken: false,
  token: null,
};

const setUserAlreadyExist = (state, action) => {
  return updateObject(state, {
    userAlreadyExist: action.user_already_exist,
    userDoesNotExist: false,
    userIdType: action.user_id_type,
    userIdNumber: action.user_id_number,
    email: action.user_email,
  });
};

const setUserDoesNotExist = (state, action) => {
  return updateObject(state, {
    userDoesNotExist: action.user_does_not_exist,
    userAlreadyExist: true,
    userIdType: action.user_id_type,
    userIdNumber: action.user_id_number,
  });
};

const setVerifyError = (state, action) => {
  return updateObject(state, {
    errorVerify: action.error,
  });
};

const setUserVerified = (state, action) => {
  return updateObject(state, {
    userVerified: action.user_verified,
  });
};

const setSendEmail = (state, action) => {
  return updateObject(state, {
    isSendEmail: action.is_send_email,
    token: action.token,
    isReSendEmail: action.is_re_send_email,
  });
};

const SetNotValidToken = (state, action) => {
  return updateObject(state, {
    loadingToken: action.loading,
    isNotValidToken: action.isNotValid,
  });
};

const verify = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_ALREADY_EXIST:
      return setUserAlreadyExist(state, action);
    case actionTypes.VERIFY_SET_ERROR:
      return setVerifyError(state, action);
    case actionTypes.SET_USER_VERIFIED:
      return setUserVerified(state, action);
    case actionTypes.SET_USER_DOES_NOT_EXIST:
      return setUserDoesNotExist(state, action);
    case actionTypes.SET_SEND_EMAIL:
      return setSendEmail(state, action);
    case actionTypes.SET_NOT_VALID_TOKEN:
      return SetNotValidToken(state, action);
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default verify;
